import classNames from 'classnames';
import classes from './SectionHeader.module.scss';

const SectionHeader = ({ title, noMarginBottom, helperContent, className, size, ...props }) => {
    return (
        <div
            className={classNames(
                classes.sectionHeader,
                noMarginBottom && classes.noMarginBottom,
                size && classes[size],
                className
            )}
            {...props}
        >
            <h3 className={classes.sectionHeaderTitle}>{title}</h3>
            {helperContent}
        </div>
    );
};

export default SectionHeader;
